import i18next from 'i18next';

i18next.addResources('es', 'CaseReport', {
  labeleds: 'Autos Caratulados: {{labeleds}}',
  fileName: 'informe',
  introduction: 'Tengo el agrado de dirigirme a usted para compartirle las siguientes intervenciones:',
  interventionsTitle: 'Síntesis de intervenciones',
  commentsTitle: 'Comentarios u observaciones'
});
